export default "__VITE_ASSET__C57Jzl1c__"